import React, { useState } from 'react';
import { Button } from "@/components/base/buttons/button";
import { Link, Check, Share2, Linkedin, Twitter, Facebook, Copy } from 'lucide-react';
import { cn } from '@/lib/utils';

const SocialShare = ({ url, title, className }) => {
    const [copied, setCopied] = useState(false);

    const handleCopyLink = () => {
        navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleSocialShare = (platform) => {
        // Copy link to clipboard first
        navigator.clipboard.writeText(url);

        // Then redirect
        let shareUrl = '';
        const encodedUrl = encodeURIComponent(url);
        const encodedTitle = encodeURIComponent(title);

        switch (platform) {
            case 'linkedin':
                shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
                break;
            case 'twitter':
                shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
                break;
            case 'facebook':
                shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
                break;
            default:
                break;
        }

        if (shareUrl) {
            window.open(shareUrl, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <div className={cn("flex items-center gap-3", className)}>
            <Button
                size="sm"
                color="secondary"
                onClick={handleCopyLink}
                iconLeading={copied ? Check : Copy}
                className={cn("transition-all text-xs font-medium h-9", copied && "text-green-600 border-green-200 bg-green-50")}
            >
                {copied ? 'Copied' : 'Copy link'}
            </Button>

            <div className="h-6 w-px bg-gray-200 mx-1"></div>

            <div className="flex gap-2">
                <Button
                    size="sm"
                    color="tertiary"
                    className="rounded-lg h-9 w-9 p-0 text-gray-500 hover:text-[#1DA1F2] hover:bg-sky-50 transition-colors"
                    onClick={() => handleSocialShare('twitter')}
                    title="Share on Twitter"
                >
                    <Twitter size={18} />
                </Button>
                <Button
                    size="sm"
                    color="tertiary"
                    className="rounded-lg h-9 w-9 p-0 text-gray-500 hover:text-[#4267B2] hover:bg-blue-50 transition-colors"
                    onClick={() => handleSocialShare('facebook')}
                    title="Share on Facebook"
                >
                    <Facebook size={18} />
                </Button>
                <Button
                    size="sm"
                    color="tertiary"
                    className="rounded-lg h-9 w-9 p-0 text-gray-500 hover:text-[#0077b5] hover:bg-blue-50 transition-colors"
                    onClick={() => handleSocialShare('linkedin')}
                    title="Share on LinkedIn"
                >
                    <Linkedin size={18} />
                </Button>
            </div>
        </div>
    );
};

export default SocialShare;
